import Cookies from 'js-cookie';
import MinProduct from '../Product/MinProduct';
import { ProductDetailItemProps } from "./constants"
import { motion } from 'framer-motion';
import { motionVariants } from '../Common/GlobalVars';


const RelatedProduct = (props: ProductDetailItemProps) => {
  const { our_pick } = props;
  const viewport = Cookies.get('viewport');

  if (our_pick[0].product_list.length === 0) {
    return (<></>)
  }

  return (
    <div className="my-8 md:my-12 pt-8 md:py-12 border-t border-[#C6C6C6]">
      <motion.h5
        className="text-center text-[32px] font-medium font-dmsans text-[#2C3E2F] mb-4 md:mb-12"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        variants={motionVariants}
      >
        You may also like
      </motion.h5>
      <div className="grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-5">
        {our_pick[0].product_list.map((product, index) => {
          return (((viewport === "desktop" && index < 5) || (viewport === "mobile" && index < 4)) &&
            <MinProduct
              attribute_value_list={product.attribute_value_list}
              brand={product.brand}
              cash_back={product.cash_back}
              id={product.id}
              main_image={product.main_image}
              image={product.image}
              name={product.name}
              product_discount_percent={product.product_discount_percent}
              // product_label_bottom_left_category_page={product.product_label_bottom_left_category_page}
              // product_label_bottom_middle_category_page={product.product_label_bottom_middle_category_page}
              // product_label_bottom_right_category_page={product.product_label_bottom_right_category_page}
              // product_label_left_category_page={product.product_label_left_category_page}
              // product_label_right_category_page={product.product_label_right_category_page}
              msrp={product.msrp}
              qty={product.qty}
              sales_price={product.sales_price}
              sku={product.sku}
              slug={product.slug}
              special_price={product.special_price}
              type={product.type}
              url={product.url}
              product_variant_list={product.product_variant_list}
              attrId={null}
              customName={null}
              key={index}
            />
          )
        })}
      </div>
    </div>
  )
}

export default RelatedProduct
